var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3755_928",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3755_928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00156 10.2768L5.32656 13.9894C5.18906 14.1283 5.01406 14.1978 4.80156 14.1978C4.58906 14.1978 4.41406 14.1283 4.27656 13.9894C4.13906 13.8505 4.07031 13.6737 4.07031 13.459C4.07031 13.2444 4.13906 13.0676 4.27656 12.9287L7.95156 9.21607L4.27656 5.50348C4.13906 5.36457 4.07031 5.18778 4.07031 4.97311C4.07031 4.75843 4.13906 4.58164 4.27656 4.44273C4.41406 4.30383 4.58906 4.23438 4.80156 4.23438C5.01406 4.23438 5.18906 4.30383 5.32656 4.44273L9.00156 8.15533L12.6766 4.44273C12.8141 4.30383 12.9891 4.23438 13.2016 4.23438C13.4141 4.23438 13.5891 4.30383 13.7266 4.44273C13.8641 4.58164 13.9328 4.75843 13.9328 4.97311C13.9328 5.18778 13.8641 5.36457 13.7266 5.50348L10.0516 9.21607L13.7266 12.9287C13.8641 13.0676 13.9328 13.2444 13.9328 13.459C13.9328 13.6737 13.8641 13.8505 13.7266 13.9894C13.5891 14.1283 13.4141 14.1978 13.2016 14.1978C12.9891 14.1978 12.8141 14.1283 12.6766 13.9894L9.00156 10.2768Z",
    fill: "#81878C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.167de2efcf0c8661d92f93901b91f0e6.svg";
export { ForwardRef as ReactComponent };